
import { defineComponent } from "vue";

export default defineComponent({
  name: "AddressProviderSwitch",
  props: {
    searchType: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => string[],
      default: () => [],
    },
  },
});
